type AvatarIconProps = {
  size?: number
}

const AvatarIcon = ({ size = 64 }: AvatarIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="111" y="100" width="290" height="312" rx="120" fill="#f47d6b" />

      <path
        d="M 70 260 A 186 186 0 0 1 442 260"
        stroke="#1f3368"
        strokeWidth="32"
        fill="none"
        strokeLinecap="round"
      />

      <rect x="40" y="210" width="75" height="120" rx="30" fill="#1f3368" />
      <rect x="397" y="210" width="75" height="120" rx="30" fill="#1f3368" />

      <path
        d="M 95 330 Q 95 430 185 410"
        stroke="#1f3368"
        strokeWidth="32"
        fill="none"
        strokeLinecap="round"
      />

      <ellipse cx="215" cy="265" rx="20" ry="26" fill="#1f3368" />
      <ellipse cx="297" cy="265" rx="20" ry="26" fill="#1f3368" />

      <path
        d="M 216 345 Q 256 385 296 345"
        stroke="#FFFFFF"
        strokeWidth="34"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  )
}

export default AvatarIcon
